import React, {useEffect, useState} from "react";
import "./style.css";
import {FOOD_DISLIKE_EAT, FOOD_OFTEN_EAT} from "../../../../const/WeightLossQuestionnaire";
import {formatCheeseName} from "../../../../utils/common";
import SwitchBtn from "../../../../components/SwitchBtn";

import { Image } from "../../../../components/Image";
export const FoodsDislikeEat = ({
  clickNext = () => {},
  clickPrev = () => {},
  value,
  clicked,
                            }) => {
  const [selectedFoods, setSelectedFoods] = useState(value || []);
  const [selectedAll, setSelectedAll] = useState(false);
  useEffect(() => {
    if (clicked) {
      clickNext(selectedFoods);
    }
  }, [clicked]);
  useEffect(() => {
    if (selectedFoods?.length === FOOD_DISLIKE_EAT?.length) {
      setSelectedAll(true);
    } else {
      setSelectedAll(false);
    }
  }, [selectedFoods])
  const handleFoodClick = (food) => {
    setSelectedFoods((prevSelected) => {
      if (prevSelected.includes(food)) {
        return prevSelected.filter((item) => item !== food);
      } else {
        return [...prevSelected, food];
      }
    });
  }

  const handleSelectAll = () => {
    if (selectedAll) {
      setSelectedFoods([]);
    } else {
      setSelectedFoods(FOOD_DISLIKE_EAT);
    }
    setSelectedAll(!selectedAll);
  }

  return (
    <div className="foods-dislike-eat" data-model-id="16761:1575">
      <div className="frame-4">
        <div className="title">
          <p className="heading">
            <span className="text-wrapper">Choose the foods you </span>

            <span className="span">don't like</span>

            <span className="text-wrapper">  to eat</span>
          </p>
        </div>

        <div className="list">
          <div className="option">Select all</div>

          <SwitchBtn onClick={handleSelectAll} value={selectedAll} />
        </div>

        <div className="frame-5">
          {FOOD_DISLIKE_EAT.map((food, index) => {
            return <div className="food" key={index}>
              <div className={`chicken-breast ${selectedFoods.includes(food) && "chicken-breast-select"}`} onClick={() => {handleFoodClick(food)}}>
                <Image src={`/static/image/questionnaire/weight-loss/foodsDislikeEat/${food}.png`} alt={food} className="img" />
              </div>
              <div className="food-name">{formatCheeseName(food)}</div>
            </div>
          })}

        </div>
      </div>
    </div>
  );
};
